export { Icon } from './src/Icon'
